import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HelpersService } from '../services/tools/helpers.service';
import { GastosService } from '../services/gastos.service';
import { GastosModalComponent } from './gastos-modal/gastos-modal.component';

import { DatesHelpersService } from '../services/tools/dates-helpers.service';
import { SucursalesService } from '../services/sucursales.service';
import { Router } from '@angular/router';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Color } from 'ng2-charts';

//import { GastosDetalladosMesComponent } from './gastos-detallados-mes/gastos-detallados-mes.component';
import * as jsPDF from 'jspdf';
//PDF
import * as _html2canvas from "html2canvas";

const html2canvas: any = _html2canvas;
declare const require: any;
require('jspdf-autotable');

@Component({
  selector: 'app-gastos',
  templateUrl: './gastos.component.html',
  styleUrls: ['./gastos.component.scss']
})
export class GastosComponent implements OnInit {
  @ViewChild('modalGastos') public modalGastos: GastosModalComponent;
  @ViewChild('btnShowDeleteModal') btnShowDeleteModal: ElementRef;

  public : any [] = [];
  public promotorToDelete = null;
  public isLoading: boolean = false;
  public mostrarListado:boolean = true;
  //Filters 
  public searchText: string = '';
  //Pagination vars
  public page: number = 1;
  public fechaInicio: string = null;
  public fechaFin: string = null;
  public sucursales: any[] = [];
  public sucursal: any = {id:null};
  public sucursalPorDefecto: string = "";
  public gastosCategorias : any[]; //Aqui estan todos los datos de categorias y se definen variables
  public gastosPorMes : any[];
  public totalListaGastos: number =0;
  public mesSeleccionado: string="";
  public numMesSeleccionado: number =0;
  public iniciarGraficaDona: boolean = false;
  public dataArray : any[];
  public gastos: any[];
  public labelsTemp: string = "";
  //Graficas
  //Barras
  // Register the plugin to all charts:
  
  public barChartOptions: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{}], yAxes: [{}] }
    
  };
  
  public barChartLabels: string[];
  public barChartType: ChartType;
  public barChartLegend = true;
  public barChartData: ChartDataSets[];
  public barChartColors: Color[] = [ { backgroundColor: [] }];
  public muestraBarras: boolean = false;

  public chartClicked(e:any): void {
    try {
      this.mesSeleccionado = e.active[0]._model.label;
      console.log("Evento", this.mesSeleccionado);
      this.getGastosGraficaDona(this.mesSeleccionado); //Llamamos a la función para graficar
    } catch (err) {}
  }
  public chartHovered(e:any): void {
    console.log(e);
  }

  // Doughnut
  public doughnutChartLabels: string[];
  public doughnutChartData: number[];
  public doughnutChartColors: Color[];
  public doughnutChartType: ChartType;
  //Bandera para saber si ya se tienen datos para graficar
  public muestraGraficaDona: boolean = false;
  // public doughnutChartType: ChartType;
  public doughnutChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display: false
    },
  };
  public chartClickedDona(e:any): void {
    console.log(e);
  }
  public chartHoveredDona(e:any): void {
    console.log(e);
  }

  constructor(
      private helperService : HelpersService,
      private service : GastosService,
      private sucursalesService : SucursalesService,
      private datesHelper : DatesHelpersService,
      private router : Router
  ){
  }

  public verReporteDetallado(){
    if (this.sucursal.id) {
      this.router.navigate(['detalle-gastos-mes/',this.mesSeleccionado,this.sucursal.id]);
    }else{
      this.router.navigate(['detalle-gastos-mes/',this.mesSeleccionado]);
    }
  }

  public ngOnInit() {
    let defaultDates = this.datesHelper.getMonthDate();
    let yearDefault = defaultDates.fechaInicio.split("-")[0];
    // this.fechaInicio = defaultDates.fechaInicio;
    this.fechaInicio = (yearDefault+"-"+"01-01");
    //console.log("Fecha Inicio: ", this.fechaInicio);
    this.fechaFin = defaultDates.fechaFin;
    this.getSucursales();
    this.getGastosPorMes();
    
  }
  
  public addGasto(){
    this.modalGastos.open(null);
  }

  public editGasto(idPromotor: number){
    this.modalGastos.open(idPromotor);
  }

  public getGastosPorMes(){
    this.barChartLabels = [];
    this.barChartType = 'bar';
    this.barChartLegend = false;
    this.barChartData = [ { data: [] } ];
    this.barChartColors = [ { backgroundColor: '#ff8900' }]
    this.muestraBarras = false;
    let filters = {
      "start-date": this.fechaInicio,
      "end-date": this.fechaFin
    }
    if (this.sucursal.id) {
      filters["idSucursales"] = this.sucursal.id;
    }
    var barDataTemp: Array <number> = [];
    this.service.getGastosMes(filters).subscribe(
      (response)=>{
        const jsonResult = response.json();
        this.gastosPorMes = jsonResult;
        this.gastosPorMes.forEach(gastoMes => {
          //Array para obtener el monto total de las categorias por el mes seleccionado
          this.barChartLabels.push(gastoMes.mes);
          barDataTemp.push(gastoMes.total);
      
        });
        //this.getGastos();
        if(barDataTemp[barDataTemp.length-1] === 0){
          this.barChartLabels.pop();
          barDataTemp.length = barDataTemp.length -1;
          this.barChartData[0].data = barDataTemp;
        }else{
          this.barChartData[0].data = barDataTemp;
        }
        //Comprobamos si se tienen datos para graficar
        if (this.barChartData.length === 0){ //Comprueba que el dataset tenga datos para graficar
          this.muestraBarras = false;
        }else{
          this.muestraBarras = true;
        }
        //Manda a poner la gráfica de dona al inicio del componente
        //Trae el ultimo mes de la gráfica de barras
        this.mesSeleccionado = this.barChartLabels[this.barChartLabels.length-1];
        this.getGastosGraficaDona(this.mesSeleccionado);
       
      },error => 
      {
        //this.isLoading = false;
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }
  public nameMesToNumber(nombreMes: string){
    switch (nombreMes){
      case "Enero": return 1;
      case "Febrero": return 2; 
      case "Marzo": return 3;  
      case "Abril": return 4; 
      case "Mayo": return 5; 
      case "Junio": return 6; 
      case "Julio": return 7; 
      case "Agosto": return 8; 
      case "Septiembre": return 9; 
      case "Octubre": return 10; 
      case "Noviembre": return 11;
      case "Diciembre": return 12;
    }
  }
  public numberMesToName(numberMes: number){
    switch (numberMes){
      case 1: return "Enero";
      case 2: return "Febrero"; 
      case 3: return "Marzo";  
      case 4: return "Abril"; 
      case 5: return "Mayo"; 
      case 6: return "Junio"; 
      case 7: return "Julio"; 
      case 8: return "Agosto"; 
      case 9: return "Septiembre"; 
      case 10: return "Octubre"; 
      case 11: return "Noviembre";
      case 12: return "Diciembre";
    }
  }
  public getGastosGraficaDona(mesSeleccionado: string) {
  this.doughnutChartLabels = [];
  this.doughnutChartData = [];
  this.doughnutChartColors = [{ backgroundColor: [] }];
  this.doughnutChartType = 'doughnut';
  this.muestraGraficaDona = false;

  const mesGrafica = this.nameMesToNumber(mesSeleccionado.split(" ")[0]);
  const yearGrafica = mesSeleccionado.split(" ")[1];

  // Genera fecha inicial al primer día del mes
  const mesStr = mesGrafica.toString().padStart(2, '0');
  const fechaInicial = `${yearGrafica}-${mesStr}-01`;

  // Calcula el último día del mes correctamente
  const lastDayDate = new Date(+yearGrafica, mesGrafica, 0);
  const dayStr = lastDayDate.getDate().toString().padStart(2, '0');
  const fechaFinal = `${yearGrafica}-${mesStr}-${dayStr}`;

  let filters = {
    "start-date": fechaInicial,
    "end-date": fechaFinal
  };

  if (this.sucursal.id) {
    filters["idSucursales"] = this.sucursal.id;
  }

  this.isLoading = true;
  let colorsTemp: string[] = [];

  this.service.getMetrics(filters).subscribe(
    (response) => {
      const jsonResult = response.json();
      this.gastosCategorias = jsonResult.content;
      this.totalListaGastos = 0;

      this.gastosCategorias.forEach(gasto => {
        this.doughnutChartLabels.push(gasto.nombre);
        this.doughnutChartData.push(gasto.monto_total);
        colorsTemp.push(gasto.color);
        this.totalListaGastos += gasto.monto_total;
      });

      this.doughnutChartColors[0].backgroundColor = colorsTemp;

      this.muestraGraficaDona = this.doughnutChartData.length > 0;
      this.isLoading = false;
    },
    (error) => {
      this.isLoading = false;
      this.helperService.httpGlobalError(error);

      if (error.status == 400) {
        this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
      }
    }
  );
}

  public getGastos(){
    this.doughnutChartLabels = [];
    this.doughnutChartData = [];
    this.doughnutChartColors = [ { backgroundColor: [] }];
    this.doughnutChartType  = 'doughnut';
    //this.doughnutChartColors = [ { } ];
    this.muestraGraficaDona = false;
    let filters = {
      "start-date": this.fechaInicio,
      "end-date": this.fechaFin
    }
    if (this.sucursal.id) {
      filters["idSucursales"] = this.sucursal.id;
    }
    this.isLoading = true;
    
    var colorsTemp: Array <string> = [];
    this.service.getMetrics(filters).subscribe(
      (response)=>
      {
        //Aqui está el arreglo de categorias con los datos
        const jsonResult = response.json();
        this.gastosCategorias = jsonResult.content;
        console.log("Array gastos ",this.gastosCategorias);
        this.gastosCategorias.forEach(gasto => {
          this.doughnutChartLabels.push(gasto.nombre);
          this.doughnutChartData.push(gasto.monto_total);
          colorsTemp.push(gasto.color);
          this.totalListaGastos = (this.totalListaGastos + gasto.monto_total);
          //datosTemp.push(gasto.monto_total);
          
        });
        // console.log("Chart Data: ", this.doughnutChartData);
        // console.log("Chart Labels: ", this.doughnutChartLabels);
        this.doughnutChartColors[0].backgroundColor=colorsTemp;
        //Comprobamos si se tienen datos para graficar
        if (this.doughnutChartData.length === 0){ //Comprueba que el dataset tenga datos para graficar
          this.muestraGraficaDona = false;
        }else{
          this.muestraGraficaDona = true;
        }
        
        //console.log("Array colors", this.doughnutChartColors);
        //Bandera que se activa cuando se pasaron los datos para graficar
        
        this.isLoading = false;
      }, error => 
      {
        this.isLoading = false;
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private getSucursales(){
    this.isLoading = true;
    this.sucursalesService.getSelect().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.sucursales = jsonResult.content;
          console.log("Sucursales: ", this.sucursales);
          if (this.sucursales.length>1){
            this.sucursalPorDefecto = "Seleccione";
          } else if(this.sucursales.length>0){
            this.sucursal =  this.sucursales[0];
          }
          //this.getGastos();
          this.isLoading = false;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  sucursalChanged(sucursal){
      if(sucursal){
          this.sucursal = sucursal;
          this.getGastos();
          this.getGastosPorMes();
      }
  }

  verGastosSubcategoria(gastoCategoria : any){
    if (this.sucursal.id) {
      this.router.navigate(["gastos/categoria/"+gastoCategoria.idCategoriasGastos+"/"+this.mesSeleccionado+"/"+this.sucursal.id]);
    }else{
      this.router.navigate(["gastos/categoria/"+gastoCategoria.idCategoriasGastos+"/"+this.mesSeleccionado]);
    }
  }

  //Función para crear PDF
  //Alternatibva para guardar pdf pero renderiza el html
  public downloadPDF() {
    this.isLoading=true;
    // Extraemos el
    const DATA = document.getElementById('htmlData');
    //const jsPDF = require('jspdf')
    const doc = new jsPDF('l');
    const options = {
      background: 'white',
      scale: 3
    };
    html2canvas(DATA, options).then((canvas) => {

      const img = canvas.toDataURL('image/jpg');
      // Add image Canvas to PDF
      const bufferX = 15;
      const bufferY = 15;
      const imgProps = (doc as any).getImageProperties(img);
      const pdfWidth = doc.internal.pageSize.getWidth() - 2 * bufferX;
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      doc.addImage(img, 'JPEG', bufferX, bufferY, pdfWidth, pdfHeight, undefined, 'FAST');
      return doc;
    }).then((docResult) => {
      this.isLoading=false;
      docResult.save("Reporte_"+this.mesSeleccionado);
    });
  }
  // public downloadPDF() {
  //   var doc = new jsPDF();
  //   doc.setFontSize(15);
  //   doc.text(15, 20, 'PROFINMEX');
  //   doc.setFontSize(13);
  //   doc.text(15, 30, 'Reporte detallado de '+this.mesSeleccionado.toLowerCase());
  //   //doc.addPage();
  //   doc.autoTable({
  //     margin: { top: 35 },
  //     head: [["Fecha", "Forma de pago", "Descripción", "Categoría", "Subcategoría", "Monto"]],
  //     body: bodyTable
  //   });
  //   doc.save("Reporte_"+this.mesSeleccionado.trim());
    
  // }


}



// WEBPACK FOOTER //
// ./src/app/gastos/gastos.component.ts